import { SafeJson } from './json';
export class ApiError extends Error {
    constructor(option) {
        super(`httpStatus=${option.httpStatus}, code=${option.code}, message=${option.message}, logId=${option.logId}`);
        this.name = 'ApiError';
        this.errorOption = option;
    }
}
export const getApiErrorRecord = (error) => {
    if (error instanceof ApiError && error.errorOption) {
        const { errorOption } = error;
        return {
            httpStatus: errorOption.httpStatus,
            code: errorOption.code,
            logId: errorOption.logId,
            response: SafeJson.stringify(errorOption.response),
            requestConfig: SafeJson.stringify(errorOption.requestConfig),
        };
    }
    return {};
};
